import { connect } from 'react-redux';

import Header from './header';

import {
  getRenderAsMobile,
  getShouldShowHeader,
  getShouldShowTitle,
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  doneScrollingToTop,
  handleSubpageDisplayed,
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

const mapStateToProps = (state) => {

  return {
    renderAsMobile: getRenderAsMobile(state),
    shouldShowTitle: getShouldShowTitle(state),
    shouldShowHeaderContents: getShouldShowHeader(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onScrolledToTop: () => {
    dispatch(doneScrollingToTop());
  },
  onSubpageDisplayedTrack: () => {
    dispatch(handleSubpageDisplayed());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
